import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  elevation?: 'none' | 'sm' | 'md' | 'lg';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  borderRadius?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  backgroundColor?: string;
  hoverEffect?: boolean;
  fullWidth?: boolean;
  className?: string;
}

const getElevation = (elevation: 'none' | 'sm' | 'md' | 'lg') => {
  switch (elevation) {
    case 'none':
      return 'none';
    case 'sm':
      return theme.shadows.sm;
    case 'md':
      return theme.shadows.md;
    case 'lg':
      return theme.shadows.lg;
    default:
      return theme.shadows.sm;
  }
};

const getPadding = (padding: 'none' | 'sm' | 'md' | 'lg') => {
  switch (padding) {
    case 'none':
      return '0';
    case 'sm':
      return theme.space.sm;
    case 'md':
      return theme.space.md;
    case 'lg':
      return theme.space.lg;
    default:
      return theme.space.md;
  }
};

const getBorderRadius = (borderRadius: 'none' | 'sm' | 'md' | 'lg' | 'xl') => {
  switch (borderRadius) {
    case 'none':
      return theme.radii.none;
    case 'sm':
      return theme.radii.sm;
    case 'md':
      return theme.radii.md;
    case 'lg':
      return theme.radii.lg;
    case 'xl':
      return theme.radii.xl;
    default:
      return theme.radii.md;
  }
};

const StyledCard = styled.div<{
  elevation: 'none' | 'sm' | 'md' | 'lg';
  padding: 'none' | 'sm' | 'md' | 'lg';
  borderRadius: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  backgroundColor: string;
  hoverEffect: boolean;
  fullWidth: boolean;
}>`
  background-color: ${props => props.backgroundColor};
  box-shadow: ${props => getElevation(props.elevation)};
  padding: ${props => getPadding(props.padding)};
  border-radius: ${props => getBorderRadius(props.borderRadius)};
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  transition: ${theme.transitions.default};
  
  ${props => props.hoverEffect && `
    &:hover {
      transform: translateY(-5px);
      box-shadow: ${theme.shadows.md};
    }
  `}
`;

export const Card: React.FC<CardProps> = ({
  children,
  elevation = 'sm',
  padding = 'md',
  borderRadius = 'md',
  backgroundColor = theme.colors.white,
  hoverEffect = false,
  fullWidth = false,
  className,
}) => {
  return (
    <StyledCard
      elevation={elevation}
      padding={padding}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      hoverEffect={hoverEffect}
      fullWidth={fullWidth}
      className={className}
    >
      {children}
    </StyledCard>
  );
};

export default Card; 